





































































































































































import Vue from 'vue'
import restaurants, { RestaurantPublic } from '@/services/Restaurants'
import storage from '@/services/Storage'
import Restaurants from '@/services/Restaurants'
import firebaseApp from '@/firebaseApp'
import auth from '@/firebaseApp'
import roles from '@/services/Roles'

export default Vue.extend({
  name: 'OwnerProfile',
  data() {
    return {
      restaurantId: this.$router.currentRoute.params.restaurantId,
      logoSmallPreviewUrl: null as string | null,
      logoBigPreviewUrl: null as string | null,
      backGroundPreviewUrl: null as string | null,
      restaurant: null as RestaurantPublic | null,
      publicRestaurants: null as string[] | null,
      ownersList: null as any,
      showTooltip: false,
    }
  },
  async created() {
    await this.setPublicRestaurants()
  },
  async mounted() {
    this.restaurant = (await restaurants.getRestaurant(this.restaurantId)).public
    this.logoSmallPreviewUrl = this.restaurant.logoSmallUrl
    this.logoBigPreviewUrl = this.restaurant.logoBigUrl
    this.backGroundPreviewUrl = this.restaurant.backgroundImageUrl

    const getOwners = firebaseApp.functions('europe-west1').httpsCallable('getOwners')
    this.ownersList = (await getOwners({ restaurantId: this.restaurantId })).data
  },
  methods: {
    async setPublicRestaurants() {
      const publicRestaurants = await Restaurants.getAllPublicRestaurants()
      if (publicRestaurants) {
        this.publicRestaurants = Object.keys(publicRestaurants)
      } else {
        this.publicRestaurants = []
      }
    },
    async publishRestaurant() {
      await Restaurants.publishRestaurant(this.restaurantId)
      this.setPublicRestaurants()
    },
    async unpublishRestaurant() {
      await Restaurants.unpublishRestaurant(this.restaurantId)
      this.setPublicRestaurants()
    },
    async forgotPassword(email: string, continueUrlPart: string) {
      const continueUrl = `${window.config.baseUrl}/${continueUrlPart}`
      await auth.auth().sendPasswordResetEmail(email, {
        url: continueUrl,
      })

      alert(`${email} ${this.$i18n.t('admin.users.receivedMail')}`)
    },
    chooseBackground() {
      ;(this.$refs.backgroundInput as HTMLInputElement).click()
    },
    chooseLogoSmall() {
      ;(this.$refs.logoSmallInput as HTMLInputElement).click()
    },
    chooseLogoBig() {
      ;(this.$refs.logoBigInput as HTMLInputElement).click()
    },
    async saveChanges() {
      //save logo small
      const logoSmall = this.getFile(this.$refs.logoSmallInput as HTMLInputElement)
      const logoSmallUrl = logoSmall
        ? await storage.saveImage(this.restaurantId, logoSmall)
        : this.restaurant?.logoSmallUrl
      if (!logoSmallUrl) {
        console.error('saveChanges - No small logo')
        return
      }

      //save logo big
      const logoBig = this.getFile(this.$refs.logoBigInput as HTMLInputElement)
      const logoBigUrl = logoBig
        ? await storage.saveImage(this.restaurantId, logoBig)
        : this.restaurant?.logoBigUrl
      if (!logoBigUrl) {
        console.error('saveChanges - No big logo')
        return
      }

      //save bg
      const background = this.getFile(this.$refs.backgroundInput as HTMLInputElement)
      const backgroundUrl = background
        ? await storage.saveImage(this.restaurantId, background)
        : this.restaurant?.backgroundImageUrl
      if (!backgroundUrl) {
        console.error('saveChanges - Geen background')
        return
      }

      const seatingWelcomeCopy = this.restaurant?.seatingWelcomeCopy
        ? this.restaurant.seatingWelcomeCopy
        : null
      const thankyouTitle = this.restaurant?.thankyouTitle ? this.restaurant.thankyouTitle : null
      const thankyouCopy = this.restaurant?.thankyouCopy ? this.restaurant.thankyouCopy : null
      const thankyouTipCopy = this.restaurant?.thankyouTipCopy
        ? this.restaurant.thankyouTipCopy
        : null

      // save the object
      const success = await restaurants.updateRestaurant(this.restaurantId, {
        name: this.restaurant?.name + '',
        backgroundImageUrl: backgroundUrl,
        logoSmallUrl,
        logoBigUrl,
        seatingWelcomeCopy,
        thankyouTitle,
        thankyouCopy,
        thankyouTipCopy,
      })

      if (!success) {
        alert(`Er ging iets mis bij het opslaan.\nDe pagina wordt herladen.`)
        window.location.reload()
        return
      }

      this.showTooltip = true
      setTimeout(() => {
        this.showTooltip = false
      }, 4000)
    },
    getFile(el: HTMLInputElement) {
      if (!el || !el.files || el.files.length === 0) {
        return null
      }

      // check size (5 MB, 5242880)
      const file = el.files[0]
      if (file.size > 5242880) {
        this.error = {
          title: 'De afbeelding is te groot',
          message: 'Deze mag maximaal 5 MB groot zijn.',
        }
        return null
      }

      this.error = null
      return file
    },
    async setBackground(e: Event) {
      const file = this.getFile(e.target as HTMLInputElement)
      if (!file) {
        return
      }

      this.backGroundPreviewUrl = (await this.convert(file)) + ''
    },
    async setLogoSmall(e: Event) {
      const file = this.getFile(e.target as HTMLInputElement)
      if (!file) {
        return
      }

      this.logoSmallPreviewUrl = (await this.convert(file)) + ''
    },
    async setLogoBig(e: Event) {
      const file = this.getFile(e.target as HTMLInputElement)
      if (!file) {
        return
      }

      this.logoBigPreviewUrl = (await this.convert(file)) + ''
    },
    convert(file: File): Promise<string | ArrayBuffer> {
      return new Promise<string | ArrayBuffer>((resolve, reject) => {
        const fileReader = new FileReader()
        if (fileReader && file) {
          fileReader.readAsDataURL(file)
          fileReader.onload = () => {
            resolve(fileReader.result + '')
          }

          fileReader.onerror = error => reject(error)
        } else {
          reject('No file provided')
        }
      })
    },
  },
  computed: {
    isFormValid() {
      if (!this.restaurant) {
        return false
      }
      // @ts-ignore
      return this.restaurant.name && this.logoSmallPreviewUrl && this.backGroundPreviewUrl
    },
    restaurantIsPublic() {
      if (!this.publicRestaurants || this.publicRestaurants.length === 0) {
        return false
      }

      return this.publicRestaurants.indexOf(this.restaurantId) !== -1
    },
    async isAdmin() {
      return await roles.isAdmin()
    },
  },
})
